import { render, staticRenderFns } from "./RejectedByPharmacyOrders.vue?vue&type=template&id=8b42e8c6"
import script from "./RejectedByPharmacyOrders.vue?vue&type=script&lang=js"
export * from "./RejectedByPharmacyOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports